export interface PrescribingOrganisationOption {
	uuid: string;
	label: string;
}

export type PrescribingOrganisationsState =
	| { status: "unavailable" }
	| { status: "loading" }
	| { status: "ready"; organisations: PrescribingOrganisationOption[] };

// CU-14ygtkjeh2z: Healthcare has no selectable-organisation read until 2B.1B provides one; new drafts fail closed until then.
export const usePrescribingOrganisations = (): PrescribingOrganisationsState => ({ status: "unavailable" });
